import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path, Rect } from "react-native-svg";

export const IconSidebarFloating: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSidebarFloating"><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor"/><Rect x="14.5" y="10.5" width="4" height="6" stroke="currentColor"/></CentralIconBase>;
});

export default IconSidebarFloating;
